
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsaf784858b6272a01e03f51a2cdd8c7a7en from './en.yaml'
            i18n.addResourceBundle('en', 'af784858b6272a01e03f51a2cdd8c7a7', flattenObject(nsaf784858b6272a01e03f51a2cdd8c7a7en), true, true);
        
        export default 'af784858b6272a01e03f51a2cdd8c7a7';
    